export default __webpack_public_path__ + "static/asiaberlin-47af61182cbd160a4e85429e4deb1f07.png";